/**
 * VPN permission prompt policy for iOS.
 *
 * The Packet Tunnel Provider requires the user to approve a VPN configuration.
 * If they deny the system dialog, the tunnel can't start and background
 * polling won't work. This module tracks that state and drives an overlay
 * that explains why VPN is needed and offers to retry.
 *
 * On Android and web this is a no-op (Android uses a foreground service,
 * no VPN permission needed).
 */

import { ref, type Ref } from "vue";

import { isIOS } from "./platform";

export const vpnPermissionPromptVisible: Ref<boolean> = ref(false);

let _vpnDenied = false;

export function markVpnPermissionDenied(): void {
  if (!isIOS()) return;
  _vpnDenied = true;
  vpnPermissionPromptVisible.value = true;
}

export function isVpnPermissionDenied(): boolean {
  return _vpnDenied;
}

export async function retryVpnPermission(): Promise<void> {
  if (!isIOS()) return;
  vpnPermissionPromptVisible.value = false;
  _vpnDenied = false;
  try {
    const { default: IpChange } = await import("./ip-change-plugin");
    await IpChange.setSessionActive({ active: true });
  } catch {
    markVpnPermissionDenied();
  }
}

export function dismissVpnPermissionPrompt(): void {
  vpnPermissionPromptVisible.value = false;
}
